import { render, staticRenderFns } from "./queryAnalysisSeller.vue?vue&type=template&id=70955585&"
import script from "./queryAnalysisSeller.vue?vue&type=script&lang=js&"
export * from "./queryAnalysisSeller.vue?vue&type=script&lang=js&"
import style0 from "./queryAnalysisSeller.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports